import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

//component
import Events from "./Events";

let EventsModal = () => (
  <div
    className="portfolio-modal modal fade"
    id="eventsModal"
    tabIndex="-1"
    role="dialog"
    aria-hidden="true"
  >
    <div className="modal-dialog">
      <div className="modal-content">
        <div
          className="close-modal"
          data-dismiss="modal"
          onClick={() => {
            document.getElementById("page-top").classList.remove("modal-open");
            document.getElementById("eventsModal").classList.remove("in");
            setTimeout(function () {
              document.getElementById("eventsModal").style.display = "none";
            }, 400);
          }}
        >
          <div className="lr">
            <div className="rl" />
          </div>
        </div>
        <Events />
        <button
          type="button"
          className="btn btn-primary"
          style={{ marginTop: "50px" }}
          data-dismiss="modal"
          onClick={() => {
            document.getElementById("page-top").classList.remove("modal-open");
            document.getElementById("eventsModal").classList.remove("in");
            setTimeout(function () {
              document.getElementById("eventsModal").style.display = "none";
            }, 400);
          }}
        >
          <i className="fa fa-times"> Close </i>
        </button>
      </div>
    </div>
  </div>
);

EventsModal.propTypes = {
  events: PropTypes.array.isRequired,
  limit: PropTypes.number,
};

const mapStateToProps = (state) => {
  return {
    events: state.events.fetched ? state.events.items : [],
    fetched: state.events.fetched,
  };
};

export default connect(mapStateToProps)(EventsModal);



// WEBPACK FOOTER //
// ./src/scenes/landingPage/components/events/Modal.js